import _ from "lodash";
export default (state: tcpinpoint.Project[] = [], action: any) => {
	switch (action.type) {
		case "GET_PROJECT_SUCCESS":
			return _.unionBy([action.resource as tcpinpoint.Project], state, "id");
		case "GET_PROJECTS_SUCCESS":
			return _.unionBy(action.resource as tcpinpoint.Project[], state, "id");
		case "DELETE_PROJECT_SUCCESS":
			return _.filter(state, resource => resource.id !== action.resource.id);
		case "CLEAR_SESSION":
			return [];
		default:
			return state;
	}
};
